import "../styles/thankYou.scss";
import { useEffect, useRef } from "react";
import axios from "axios";
import Nav from "../Nav";

export default function ThankYou() {
  const effectRan = useRef(false);
  const url = 'https://dev.pmwwebdesign.com';
  // const url = 'http://localhost:3999';

  useEffect(() => {
    // TODO: sent registration
    let att = localStorage.getItem("ftClient");
    console.log(`att: ${att}`)
    let attendee = JSON.parse(att);
    console.log(attendee)
    if (attendee && !effectRan.current) {
      axios.post(`${url}/property/fastrack-fully`, attendee)
        .then((res) => {
          localStorage.removeItem("dfyClient");
          console.log('removed from mongo')
        })
        .catch((err) => {
          console.log(err);
        });
      return () => (effectRan.current = true);
    }
  }, [effectRan]);

  return (
    <main className="thank__main">
      <Nav />
      <h2>Thank You For Joining The Fast Track Programme</h2>
      <h4>You will receive all the information direct to your email</h4>
    </main>
  );
}
